// extracted by mini-css-extract-plugin
export default {"categories-list-container":"_3DULI","categoriesListContainer":"_3DULI"};